<template>
  <HeaderCustom title="Gestão do Conhecimento">
    <CardParametrosConsulta />

    <v-row class="mt-4">
      <v-col>
        <ResultadoConsulta v-show="result?.totalHits" />
      </v-col>
    </v-row>
  </HeaderCustom>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import HeaderCustom from '../components/HeaderCustom.vue';
import CardParametrosConsulta from './components/CardParametrosConsulta.vue';
import ResultadoConsulta from './components/ResultadoConsulta.vue';
import { usePublicoParecerReferencialStore } from './store/PublicoParecerReferencialStore';

const store = usePublicoParecerReferencialStore();

const { result } = storeToRefs(store);
</script>
